import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { TableColumn } from 'src/app/models/TableColumn';


import { Location, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent, TButtonAction } from '../../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
    selector: 'app-list-distributor-staff',
    templateUrl: './list-distributor-staff.component.html',
    styleUrl: './list-distributor-staff.component.scss',
    imports: [
        CommonModule,
        FormsModule,
        TableControlComponent,
        TooltipDirective
    ]
})
export class ListDistributorStaffComponent {
  @Input() distributorDataInput: any;
  @Input() readOnly = false;
  distributorStaffList: UserDTO[] = [];
  filteredStaffUsers: any[] = [];
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans',
    'numberDevices',
  ];
  isFilteredByStatus: boolean = false;
  originalDistributorStaffList: any[] = [];
  public selectedStaffUser: UserDTO = {} as UserDTO;
  idModule: number = 4;
  alert: Alert = {} as Alert;
  userRequestDTO: UserRequestDTO = {
    userId: undefined,
  };


  columns: TableColumn[] = [
    { key: 'userId', header: 'User Account' },
    { key: 'userNames', header: 'Name', width: 250 },
    { key: 'userMail', header: 'Email', width: 250 },
    { key: 'userPhone', header: 'Contact Number' },
    /*
    { key: 'userStatus', header: 'Status', width: 250 },
    */
  ];

  actionButtons: TButtonAction[] = [
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil', hidden: () => !this.permissionsService.editPermission },
    { label: 'archive', class: 'danger', icon: 'bi bi-archive', hidden: () => !this.permissionsService.editPermission },

  ];

  public location = inject(Location);
  private customerService = inject(CustomerService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private alertService = inject(AlertService);
  public permissionsService = inject(ValidatePermissionsService);
  public paginationService = inject(PaginationService);

  ngOnInit() {


    this.loadDistributorStaff();
  }


  loadDistributorStaff() {
    this.userRequestDTO.userId = this.distributorDataInput.userId ? this.distributorDataInput.userId : this.distributorDataInput;
    this.customerService.getListUsersOfStaff(this.userRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListStaffUsers(Data);
        } else {
          this.HandleGetListStaffUsersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );

  }

  onAction(event: { action: string; item: UserDTO }): void {

    switch (event.action) {

      case 'edit':
        this.navigateToUpdateUser(event.item)
        break;
      case 'archive':
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modalArchive')).show()


        this.setArchivedStaffUser(event.item)
        break;
    }
  }


  HandleGetListStaffUsersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListStaffUsers(distributorStaffList: UserDTO[]) {
    // Guarda la lista de clientes original
    this.distributorStaffList = distributorStaffList;
    this.originalDistributorStaffList = this.distributorStaffList.slice();
    this.distributorStaffList = this.originalDistributorStaffList.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
  }





  setSelectedStaffUser(staffUser: any) {
    this.selectedStaffUser = staffUser;
  }

  setArchivedStaffUser(staffUser: any) {
    this.selectedStaffUser = staffUser;
    this.selectedStaffUser.userStatus = 2;
  }

  openConfirmationModal(staffUser: any) {
    this.selectedStaffUser = staffUser;
  }

  updateUserStatus(confirmed: boolean) {
    if (confirmed) {
      this.customerService
        .updateCustomerStatus(this.selectedStaffUser)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateDistributorStaffStatus(Data);
            } else {
              this.HandleUpdateDistributorStaffStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      this.loadDistributorStaff();
    }
  }

  HandleUpdateDistributorStaffStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateDistributorStaffStatus(staffUser: boolean) {
    this.alert = {
      alertMessage: 'Distributor Staff User status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  public navigateToUpdateUser(staffUser: any) {
    this.router.navigate(['/distributors/update-distributor-staff'], {
      relativeTo: this.route,
      state: { userData: staffUser },
    });
  }

  public navigateToDistributorUsers() {
    this.router.navigate(['/distributors/distributor-staff'], {
      relativeTo: this.route,
      state: { distributorData: this.distributorDataInput },
    });
  }

  public goBack() {
    //window.location.href = '/home';
    this.location.back();
  }


}
